import React, { lazy, Suspense } from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import 'firebase/auth';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import ReactDOM from 'react-dom';

import './index.css';

import firebase from './firebase';
import FirebaseContext from './FirebaseContext';
import { ThemeProvider } from './contexts/ThemeContext';

import Loading from './Components/Loading';

const AuthenticatedApp = lazy(() => import('./AuthenticatedApp'));
const UnauthenticatedApp = lazy(() => import('./UnauthenticatedApp'));
const ConnectMcp = lazy(() => import('./Views/account/ConnectMcp'));

function App() {
  const [user] = useAuthState(firebase.auth());

  return (
    <ThemeProvider>
      <Suspense fallback={<Loading />}>
        <FirebaseContext.Provider value={firebase}>
          <Router>
            <Routes>
              <Route path="/connect-mcp" element={<ConnectMcp />} />
              <Route
                path="/*"
                element={user ? <AuthenticatedApp /> : <UnauthenticatedApp />}
              />
            </Routes>
          </Router>
        </FirebaseContext.Provider>
      </Suspense>
    </ThemeProvider>
  );
}

ReactDOM.render(<App />, document.getElementById('root'));
